export const regions = [
    {
        "id": 7,
        "oktmoCode": "10000000",
        "name": "Амурская область",
        "x": 127.54,
        "y": 50.2796,
        "capitalName": "Благовещенск"
    },
    {
        "id": 86,
        "oktmoCode": "98000000",
        "name": "Республика Саха (Якутия)",
        "x": 129.733,
        "y": 62.0339,
        "capitalName": "Якутск"
    },
    {
        "id": 8,
        "oktmoCode": "11000000",
        "name": "Архангельская область",
        "x": 40.5433,
        "y": 64.5401,
        "capitalName": "Архангельск"
    },
    {
        "id": 75,
        "oktmoCode": "87000000",
        "name": "Республика Коми",
        "x": 50.8099,
        "y": 61.6764,
        "capitalName": "Сыктывкар"
    },
    {
        "id": 9,
        "oktmoCode": "12000000",
        "name": "Астраханская область",
        "x": 48.0408,
        "y": 46.3497,
        "capitalName": "Астрахань"
    },
    {
        "id": 10,
        "oktmoCode": "14000000",
        "name": "Белгородская область",
        "x": 36.5802,
        "y": 50.6107,
        "capitalName": "Белгород"
    },
    {
        "id": 15,
        "oktmoCode": "20000000",
        "name": "Воронежская область",
        "x": 39.1843,
        "y": 51.672,
        "capitalName": "Воронеж"
    },
    {
        "id": 70,
        "oktmoCode": "82000000",
        "name": "Республика Дагестан",
        "x": 47.5024,
        "y": 42.9764,
        "capitalName": "Махачкала"
    },
    {
        "id": 18,
        "oktmoCode": "23000000",
        "name": "Запорожская область",
        "x": 35.1903,
        "y": 47.8229,
        "capitalName": "Запорожье"
    },
    {
        "id": 62,
        "oktmoCode": "74000000",
        "name": "Херсонская область",
        "x": 32.6178,
        "y": 46.6558,
        "capitalName": "Херсон"
    },
    {
        "id": 12,
        "oktmoCode": "17000000",
        "name": "Владимирская область",
        "x": 40.3966,
        "y": 56.1366,
        "capitalName": "Владимир"
    },
    {
        "id": 19,
        "oktmoCode": "24000000",
        "name": "Ивановская область",
        "x": 40.9714,
        "y": 56.9972,
        "capitalName": "Иваново"
    },
    {
        "id": 16,
        "oktmoCode": "21000000",
        "name": "Республика Донецкая Народная",
        "x": 39.9595,
        "y": 48.3396,
        "capitalName": "Донецк"
    },
    {
        "id": 36,
        "oktmoCode": "43000000",
        "name": "Республика Луганская Народная",
        "x": 39.3171,
        "y": 48.5671,
        "capitalName": "Луганск"
    },
    {
        "id": 64,
        "oktmoCode": "76000000",
        "name": "Забайкальский край",
        "x": 113.501,
        "y": 52.0317,
        "capitalName": "Чита"
    },
    {
        "id": 20,
        "oktmoCode": "25000000",
        "name": "Иркутская область",
        "x": 104.296,
        "y": 52.2978,
        "capitalName": "Иркутск"
    },
    {
        "id": 69,
        "oktmoCode": "81000000",
        "name": "Республика Бурятия",
        "x": 107.606,
        "y": 51.8272,
        "capitalName": "Улан-Удэ"
    },
    {
        "id": 22,
        "oktmoCode": "27000000",
        "name": "Калининградская область",
        "x": 20.511,
        "y": 54.7065,
        "capitalName": "Калининград"
    },
    {
        "id": 48,
        "oktmoCode": "57000000",
        "name": "Пермский край",
        "x": 56.2502,
        "y": 58.0105,
        "capitalName": "Пермь"
    },
    {
        "id": 27,
        "oktmoCode": "33000000",
        "name": "Кировская область",
        "x": 49.6601,
        "y": 58.5966,
        "capitalName": "Киров"
    },
    {
        "id": 3,
        "oktmoCode": "04000000",
        "name": "Красноярский край",
        "x": 92.8672,
        "y": 56.0184,
        "capitalName": "Красноярск"
    },
    {
        "id": 77,
        "oktmoCode": "89000000",
        "name": "Республика Мордовия",
        "x": 45.1749,
        "y": 54.1838,
        "capitalName": "Саранск"
    },
    {
        "id": 38,
        "oktmoCode": "45000000",
        "name": "г. Москва",
        "x": 37.6156,
        "y": 55.7522,
        "capitalName": "Москва"
    },
    {
        "id": 39,
        "oktmoCode": "46000000",
        "name": "Московская область",
        "x": 37.6156,
        "y": 55.7522,
        "capitalName": "Москва"
    },
    {
        "id": 59,
        "oktmoCode": "70000000",
        "name": "Тульская область",
        "x": 37.6182,
        "y": 54.1961,
        "capitalName": "Тула"
    },
    {
        "id": 17,
        "oktmoCode": "22000000",
        "name": "Нижегородская область",
        "x": 44.002,
        "y": 56.3287,
        "capitalName": "Нижний Новгород"
    },
    {
        "id": 43,
        "oktmoCode": "52000000",
        "name": "Омская область",
        "x": 73.3686,
        "y": 54.9924,
        "capitalName": "Омск"
    },
    {
        "id": 32,
        "oktmoCode": "38000000",
        "name": "Курская область",
        "x": 36.1874,
        "y": 51.7373,
        "capitalName": "Курск"
    },
    {
        "id": 45,
        "oktmoCode": "54000000",
        "name": "Орловская область",
        "x": 36.0785,
        "y": 52.9651,
        "capitalName": "Орёл"
    },
    {
        "id": 44,
        "oktmoCode": "53000000",
        "name": "Оренбургская область",
        "x": 55.0988,
        "y": 51.7727,
        "capitalName": "Оренбург"
    },
    {
        "id": 4,
        "oktmoCode": "05000000",
        "name": "Приморский край",
        "x": 131.874,
        "y": 43.1056,
        "capitalName": "Владивосток"
    },
    {
        "id": 37,
        "oktmoCode": "44000000",
        "name": "Магаданская область",
        "x": 150.803,
        "y": 59.5638,
        "capitalName": "Магадан"
    },
    {
        "id": 30,
        "oktmoCode": "36000000",
        "name": "Самарская область",
        "x": 50.15,
        "y": 53.2001,
        "capitalName": "Самара"
    },
    {
        "id": 14,
        "oktmoCode": "19000000",
        "name": "Вологодская область",
        "x": 39.884,
        "y": 59.2239,
        "capitalName": "Вологда"
    },
    {
        "id": 34,
        "oktmoCode": "41000000",
        "name": "Ленинградская область",
        "x": 30.3141,
        "y": 59.9386,
        "capitalName": "Санкт-Петербург"
    },
    {
        "id": 33,
        "oktmoCode": "40000000",
        "name": "г. Санкт-Петербург",
        "x": 30.3141,
        "y": 59.9386,
        "capitalName": "Санкт-Петербург"
    },
    {
        "id": 80,
        "oktmoCode": "92000000",
        "name": "Республика Татарстан",
        "x": 49.1221,
        "y": 55.7887,
        "capitalName": "Казань"
    },
    {
        "id": 42,
        "oktmoCode": "50000000",
        "name": "Новосибирская область",
        "x": 82.9346,
        "y": 55.0415,
        "capitalName": "Новосибирск"
    },
    {
        "id": 26,
        "oktmoCode": "32000000",
        "name": "Кемеровская область",
        "x": 86.0833,
        "y": 55.3333,
        "capitalName": "Кемерово"
    },
    {
        "id": 54,
        "oktmoCode": "65000000",
        "name": "Свердловская область",
        "x": 60.6122,
        "y": 56.8519,
        "capitalName": "Екатеринбург"
    },
    {
        "id": 83,
        "oktmoCode": "95000000",
        "name": "Республика Хакасия",
        "x": 91.4292,
        "y": 53.7156,
        "capitalName": "Абакан"
    },
    {
        "id": 81,
        "oktmoCode": "93000000",
        "name": "Республика Тыва",
        "x": 94.4534,
        "y": 51.7147,
        "capitalName": "Кызыл"
    },
    {
        "id": 61,
        "oktmoCode": "73000000",
        "name": "Ульяновская область",
        "x": 48.3866,
        "y": 54.3282,
        "capitalName": "Ульяновск"
    },
    {
        "id": 85,
        "oktmoCode": "97000000",
        "name": "Чувашская Республика",
        "x": 47.2519,
        "y": 56.1322,
        "capitalName": "Чебоксары"
    },
    {
        "id": 67,
        "oktmoCode": "79000000",
        "name": "Республика Адыгея",
        "x": 40.1058,
        "y": 44.6078,
        "capitalName": "Майкоп"
    },
    {
        "id": 2,
        "oktmoCode": "03000000",
        "name": "Краснодарский край",
        "x": 38.976,
        "y": 45.0448,
        "capitalName": "Краснодар"
    },
    {
        "id": 11,
        "oktmoCode": "15000000",
        "name": "Брянская область",
        "x": 34.3717,
        "y": 53.2521,
        "capitalName": "Брянск"
    },
    {
        "id": 24,
        "oktmoCode": "29000000",
        "name": "Калужская область",
        "x": 36.2754,
        "y": 54.5293,
        "capitalName": "Калуга"
    },
    {
        "id": 51,
        "oktmoCode": "61000000",
        "name": "Рязанская область",
        "x": 39.6916,
        "y": 54.6269,
        "capitalName": "Рязань"
    },
    {
        "id": 57,
        "oktmoCode": "68000000",
        "name": "Тамбовская область",
        "x": 41.4433,
        "y": 52.7317,
        "capitalName": "Тамбов"
    },
    {
        "id": 66,
        "oktmoCode": "78000000",
        "name": "Ярославская область",
        "x": 39.8737,
        "y": 57.6299,
        "capitalName": "Ярославль"
    },
    {
        "id": 23,
        "oktmoCode": "28000000",
        "name": "Тверская область",
        "x": 35.9006,
        "y": 56.8584,
        "capitalName": "Тверь"
    },
    {
        "id": 21,
        "oktmoCode": "26000000",
        "name": "Республика Ингушетия",
        "x": 44.7726,
        "y": 43.2226,
        "capitalName": "Магас"
    },
    {
        "id": 84,
        "oktmoCode": "96000000",
        "name": "Чеченская Республика",
        "x": 45.6889,
        "y": 43.312,
        "capitalName": "Грозный"
    },
    {
        "id": 5,
        "oktmoCode": "07000000",
        "name": "Ставропольский край",
        "x": 41.9734,
        "y": 45.0428,
        "capitalName": "Ставрополь"
    },
    {
        "id": 79,
        "oktmoCode": "91000000",
        "name": "Карачаево-Черкесская Республика",
        "x": 42.0578,
        "y": 44.2233,
        "capitalName": "Черкесский"
    },
    {
        "id": 60,
        "oktmoCode": "71000000",
        "name": "Тюменская область, ХМАО, ЯНАО",
        "x": 65.5272,
        "y": 57.1522,
        "capitalName": "Тюмень"
    },
    {
        "id": 72,
        "oktmoCode": "84000000",
        "name": "Республика Алтай",
        "x": 85.9189,
        "y": 51.9606,
        "capitalName": "Горно-Алтайск"
    },
    {
        "id": 1,
        "oktmoCode": "01000000",
        "name": "Алтайский край",
        "x": 83.7636,
        "y": 53.3606,
        "capitalName": "Барнаул"
    },
    {
        "id": 68,
        "oktmoCode": "80000000",
        "name": "Республика Башкортостан",
        "x": 55.9678,
        "y": 54.7431,
        "capitalName": "Уфа"
    },
    {
        "id": 40,
        "oktmoCode": "47000000",
        "name": "Мурманская область",
        "x": 33.0925,
        "y": 68.9792,
        "capitalName": "Мурманск"
    },
    {
        "id": 74,
        "oktmoCode": "86000000",
        "name": "Республика Карелия",
        "x": 34.3469,
        "y": 61.7849,
        "capitalName": "Петрозаводск"
    },
    {
        "id": 13,
        "oktmoCode": "18000000",
        "name": "Волгоградская область",
        "x": 44.5018,
        "y": 48.7194,
        "capitalName": "Волгоград"
    },
    {
        "id": 73,
        "oktmoCode": "85000000",
        "name": "Республика Калмыкия",
        "x": 44.2558,
        "y": 46.3078,
        "capitalName": "Элиста"
    },
    {
        "id": 50,
        "oktmoCode": "60000000",
        "name": "Ростовская область",
        "x": 39.7233,
        "y": 47.2313,
        "capitalName": "Ростов-на-Дону"
    },
    {
        "id": 35,
        "oktmoCode": "42000000",
        "name": "Липецкая область",
        "x": 39.5708,
        "y": 52.6031,
        "capitalName": "Липецк"
    },
    {
        "id": 56,
        "oktmoCode": "67000000",
        "name": "г. Севастополь",
        "x": 33.31,
        "y": 44.37,
        "capitalName": "Севастополь"
    },
    {
        "id": 29,
        "oktmoCode": "35000000",
        "name": "Республика Крым",
        "x": 34.1108,
        "y": 44.9572,
        "capitalName": "Симферополь"
    },
    {
        "id": 28,
        "oktmoCode": "34000000",
        "name": "Костромская область",
        "x": 40.9269,
        "y": 57.7665,
        "capitalName": "Кострома"
    },
    {
        "id": 82,
        "oktmoCode": "94000000",
        "name": "Удмуртская Республика",
        "x": 53.2045,
        "y": 56.8498,
        "capitalName": "Ижевск"
    },
    {
        "id": 47,
        "oktmoCode": "56000000",
        "name": "Пензенская область",
        "x": 53.2007,
        "y": 45.0046,
        "capitalName": "Пенза"
    },
    {
        "id": 76,
        "oktmoCode": "88000000",
        "name": "Республика Марий Эл",
        "x": 47.8908,
        "y": 56.6388,
        "capitalName": "Йошкар-Ола"
    },
    {
        "id": 25,
        "oktmoCode": "30000000",
        "name": "Камчатский край",
        "x": 158.651,
        "y": 53.0444,
        "capitalName": "Петропавловск-Камчатский"
    },
    {
        "id": 53,
        "oktmoCode": "64000000",
        "name": "Сахалинская область",
        "x": 142.736,
        "y": 46.9541,
        "capitalName": "Южно-Сахалинск"
    },
    {
        "id": 87,
        "oktmoCode": "99000000",
        "name": "Еврейская автономная область",
        "x": 132.924,
        "y": 48.7928,
        "capitalName": "Биробиджан"
    },
    {
        "id": 65,
        "oktmoCode": "77000000",
        "name": "Чукотский автономный округ",
        "x": 177.51,
        "y": 64.7342,
        "capitalName": "Анадырь"
    },
    {
        "id": 6,
        "oktmoCode": "08000000",
        "name": "Хабаровский край",
        "x": 135.084,
        "y": 48.4827,
        "capitalName": "Хабаровск"
    },
    {
        "id": 52,
        "oktmoCode": "63000000",
        "name": "Саратовская область",
        "x": 46.0086,
        "y": 51.5406,
        "capitalName": "Саратов"
    },
    {
        "id": 49,
        "oktmoCode": "58000000",
        "name": "Псковская область",
        "x": 28.3496,
        "y": 57.8136,
        "capitalName": "Псков"
    },
    {
        "id": 41,
        "oktmoCode": "49000000",
        "name": "Новгородская область",
        "x": 31.271,
        "y": 58.5213,
        "capitalName": "Великий Новгород"
    },
    {
        "id": 58,
        "oktmoCode": "69000000",
        "name": "Томская область",
        "x": 84.9744,
        "y": 56.4977,
        "capitalName": "Томск"
    },
    {
        "id": 31,
        "oktmoCode": "37000000",
        "name": "Курганская область",
        "x": 65.3333,
        "y": 55.45,
        "capitalName": "Курган"
    },
    {
        "id": 63,
        "oktmoCode": "75000000",
        "name": "Челябинская область",
        "x": 61.4291,
        "y": 55.154,
        "capitalName": "Челябинск"
    },
    {
        "id": 55,
        "oktmoCode": "66000000",
        "name": "Смоленская область",
        "x": 32.0401,
        "y": 54.7818,
        "capitalName": "Смоленск"
    },
    {
        "id": 78,
        "oktmoCode": "90000000",
        "name": "Республика Северная Осетия - Алания",
        "x": 44.6678,
        "y": 43.0367,
        "capitalName": "Владикавказ"
    },
    {
        "id": 71,
        "oktmoCode": "83000000",
        "name": "Кабардино-Балкарская Республика",
        "x": 43.6189,
        "y": 43.4981,
        "capitalName": "Нальчик"
    }
]